/** A measured, interruptible scroll for automatic carousel transitions. */
export default function animate_carousel_scroll(node, left, onfinish, oninterrupt) {
  const window = node.ownerDocument.defaultView;
  const duration = 1200;
  const start = node.scrollLeft;
  const started = window.performance.now();
  const properties = ['scroll-snap-type', 'scroll-behavior'];
  const previous = properties.map(property => [
    property, node.style.getPropertyValue(property), node.style.getPropertyPriority(property),
  ]);
  let frame;
  let active = true;
  let last_position = start;

  // Native snapping would otherwise snap every individual animation frame.
  // The cards keep their snap points; restore the container when the motion ends.
  node.style.setProperty('scroll-snap-type', 'none', 'important');
  node.style.setProperty('scroll-behavior', 'auto', 'important');

  function restore() {
    for (const [property, value, priority] of previous) {
      if (value) node.style.setProperty(property, value, priority);
      else node.style.removeProperty(property);
    }
  }

  function step(now) {
    if (!active) return;
    // Native touch scrolling can begin after pointercancel, without another
    // pointermove. Yield if the browser moved since our last frame instead of
    // overwriting the user's movement on the next frame.
    if (Math.abs(node.scrollLeft - last_position) > 2) {
      cancel();
      oninterrupt?.();
      return;
    }
    const progress = Math.min(1, (now - started) / duration);
    // Sine ease-in-out: gentle acceleration and deceleration with no abrupt peak.
    const eased = (1 - Math.cos(Math.PI * progress)) / 2;
    node.scrollTo({ left: start + (left - start) * eased, behavior: 'instant' });
    last_position = node.scrollLeft;
    if (progress < 1) {
      frame = window.requestAnimationFrame(step);
    } else {
      active = false;
      restore();
      node.scrollTo({ left, behavior: 'instant' });
      onfinish?.();
    }
  }

  function cancel() {
    if (!active) return;
    active = false;
    window.cancelAnimationFrame(frame);
    // Do not write scrollLeft here: an instant write after re-enabling snap
    // jumps to a snap point and interrupts the user's native wheel/touch motion.
    restore();
  }

  frame = window.requestAnimationFrame(step);
  return cancel;
}
